import React, { useEffect, useState } from 'react'
import SubHeadsService from "../Accounts/Subhead/SubHeadsService.js"
import { Autocomplete, Table, TableBody, TableCell, TableRow } from '@mui/material'
import { currentTenant,userid } from '../Common/Credentials'
import SettingsServices from './SettingsServices'

const MasterLedgerMapping = () => {
    const [id,setId] = useState(null) 
    const [ledGroups,setLedGroups] = useState([])
    const [mastertypes,setMastertypes] = useState(["Customer","Supplier"])
    const [mastertype,setMastertype] = useState(null)
    const [types,setTypes] = useState(["Domestic","International"])
    const [type,setType] = useState(null)
    const [ledgergroup,setLedgergroup] = useState(null)
    const [masterLedgers,setMasterLedgers] = useState([])
    const [subHeads,setSubheads] = useState([])
    const [subHead,setSubhead] = useState(null)
    const [error,setError] = useState("")

    useEffect(()=>{
        Promise.all([
            SubHeadsService.getLedGroups(currentTenant),
            SubHeadsService.getSubHeads(currentTenant)
          ]).then(([ledGroupsRes, subHeadsRes]) => {
            const ledGroupsData = ledGroupsRes.data;
            const subHeadsData = subHeadsRes.data;
          
            setLedGroups(ledGroupsData);
            setSubheads(subHeadsData);
          
            // Call fetch once with both datasets
            fetch({
              ledGroups: ledGroupsData,
              subHeads: subHeadsData
            });
          }).catch((error) => {
            console.error("Error fetching data:", error);
          });
        
    },[])
    const fetch = (data) =>{
        SettingsServices.getAllMasterLedgerMapping(currentTenant).then((res)=>{
            let masterdata = []
            masterdata = res.data.map(e=>{return {...e,ledgergroup:data.ledGroups.find(l=>l.id === e.ledgergroup),subhead:data.subHeads.find(l=>l.id === e.subhead)}})
            setMasterLedgers([...masterdata])
        })
    }
    const deleteMasterLedgerMapping =(id)=> {
        SettingsServices.deleteMasterLedgerMapping(id).then(()=>{
            fetch({
                ledGroups: ledGroups,
                subHeads: subHeads
              })
        })
    }
    const validateDate = () =>{
        if(!mastertype){
            setError("Select Master")
            return false
        }
        if(!type){
            setError("Select Ledger Type")
            return false
        }
        // if(!ledgergroup){
        //     setError("Select Ledger Group")
        //     return false
        // }
        if(!subHead){
            setError("Select Ledger Sub Head")
            return false
        }
        let data = masterLedgers.find(e=>e.mastertype === mastertype && e.type ===type)
        if(data){
            setError("Ledger Mapping Alredy Exists")
            return false
        }
        setError("")
        return true
    }

    const handleMasterLedgerUpdate = () =>{
        const validate = validateDate()
        if(validate){
            let req = {
                id:id,
                mastertype:mastertype,
                ledgergroup:ledgergroup?.id,
                type:type,
                subhead:subHead?.id,
                updatedby:userid,
                tenantId:currentTenant
            }
            SettingsServices.updateMasterLedgerMapping(req).then(()=>{
                fetch({
                    ledGroups: ledGroups,
                    subHeads: subHeads
                  })
            })
        }
    }

    
  return (<>
    <Table className="table-sm m-0 p-0 table-bordred">
    <TableBody>
      <TableRow>
        <TableCell className="text-md text-secondary p-3 font-weight-bold">
          Master Ledger Mapping
        </TableCell>
        <TableCell></TableCell>
        <TableCell></TableCell>
        <TableCell></TableCell>
      </TableRow>
      <TableRow>
        <TableCell className="text-md text-secondary p-3">
          <Autocomplete
                                                       id="currency"
                                                       name="currency"
                                                       options={mastertypes}
                                                       getOptionLabel={(option) => option}
                                                       value={mastertype}
                                                       onChange={(value,values)=>setMastertype(values)}
                                                       renderInput={(params) => (
                                                           <div ref={params.InputProps.ref} style={{ position: 'relative', }}>
                                                               <input
                                                                   type="text"
                                                                   {...params.inputProps}
                                                                   className="UI-input"
                                                                   placeholder="Select Master"
                                                                   value={mastertype}
                                                                   style={{
                                                                       width: '100%',
                                                                       // paddingRight: currency && currency !== basecurrency ? '30px' : undefined
                                                                   }}
                                                               />
                                                           </div>
                                                       )}
                                                   />
        </TableCell>
        <TableCell>
        <Autocomplete
                                                       id="currency"
                                                       name="currency"
                                                       options={types}
                                                       getOptionLabel={(option) => option}
                                                       value={type}
                                                       onChange={(value,values)=>setType(values)}
                                                       renderInput={(params) => (
                                                           <div ref={params.InputProps.ref} style={{ position: 'relative', }}>
                                                               <input
                                                                   type="text"
                                                                   {...params.inputProps}
                                                                   className="UI-input"
                                                                   placeholder="Select Ledger Type"
                                                                   value={type}
                                                                   style={{
                                                                       width: '100%',
                                                                       // paddingRight: currency && currency !== basecurrency ? '30px' : undefined
                                                                   }}
                                                               />
                                                           </div>
                                                       )}
                                                   />
                                                </TableCell>
                                                <TableCell>
                                                <Autocomplete
                                                       id="currency"
                                                       name="currency"
                                                       options={ledGroups}
                                                       getOptionLabel={(option) => option.name}
                                                       value={ledgergroup}
                                                       // onChange={this.handleTaxtypeChange}
                                                       onChange={(value,values)=>setLedgergroup(values)}
                                                       renderInput={(params) => (
                                                           <div ref={params.InputProps.ref} style={{ position: 'relative', }}>
                                                               <input
                                                                   type="text"
                                                                   {...params.inputProps}
                                                                   className="UI-input"
                                                                   placeholder="Select Ledger Group"
                                                                //    value={taxtype}
                                                                   style={{
                                                                       width: '100%',
                                                                       // paddingRight: currency && currency !== basecurrency ? '30px' : undefined
                                                                   }}
                                                               />
                                                           </div>
                                                       )}
                                                   />
        </TableCell>
        <TableCell>
                                                <Autocomplete
                                                       id="currency"
                                                       name="currency"
                                                       options={subHeads}
                                                       getOptionLabel={(option) => option.name}
                                                       value={subHead}
                                                       // onChange={this.handleTaxtypeChange}
                                                       onChange={(value,values)=>setSubhead(values)}
                                                       renderInput={(params) => (
                                                           <div ref={params.InputProps.ref} style={{ position: 'relative', }}>
                                                               <input
                                                                   type="text"
                                                                   {...params.inputProps}
                                                                   className="UI-input"
                                                                   placeholder="Select Ledger Sub Head"
                                                                //    value={taxtype}
                                                                   style={{
                                                                       width: '100%',
                                                                       // paddingRight: currency && currency !== basecurrency ? '30px' : undefined
                                                                   }}
                                                               />
                                                           </div>
                                                       )}
                                                   />
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
  {error && error !=="" && <div className='tw-text-red-500 tw-text-xs tw-ml-3'>{error}</div>}
  <button className='btn btn-sm hovbuttonColour ml-3' onClick={handleMasterLedgerUpdate}>Save</button>
  {masterLedgers && masterLedgers.length>0 && 
  <Table className="table-sm m-0 p-0 table-bordred">
    <TableBody>
      <TableRow>
        <TableCell className="text-md text-secondary p-3 font-weight-bold">
          Mapped Ledger Masters
        </TableCell>
        <TableCell>Type</TableCell>
        <TableCell>Ledger Group</TableCell>
        <TableCell>Sub Head</TableCell>
        <TableCell>Action</TableCell>
      </TableRow>
      {masterLedgers.map((e,idx)=>
      <TableRow key={idx}>
       <TableCell>{e.mastertype}</TableCell>
       <TableCell>{e.type}</TableCell>
       <TableCell>{e.ledgergroup?.name}</TableCell>
       <TableCell>{e.subhead?.name}</TableCell>
        <TableCell><button className='btn btn-sm hovbuttonColour' onClick={()=>deleteMasterLedgerMapping(e.id)}>Delete</button></TableCell>
      </TableRow>)}
    </TableBody>
  </Table>}
  </>
  )
}

export default MasterLedgerMapping